// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"be1c4289","366":"0661b89c","403":"3391ec68","544":"fa1de753","726":"71e5cd1c","787":"246df7ae","922":"7b46fd20","971":"1d3a1380"}[chunkId] + ".chunk.js";
};